export default __webpack_public_path__ + "static/media/633781.4571ac6e.png";